<div id="layout" class="layout_sm"  [class.layout_sm]="!api.userRole.isCustomer">
    <app-scanner (hasStarted)="hasStarted()" (scan)="scanResult($event)" description="scanner.userActivate"></app-scanner>
    <app-back-btn position="botLeft" (click)="enroll.navigate('previous')"></app-back-btn>
</div>
